import { BiUser } from "@react-icons/all-files/bi/BiUser";
import "./about.css"
import { Link } from "react-scroll";
import AOS from "aos";
import "aos/dist/aos.css";
const About = () => {
    AOS.init();
  return (
    <div
      className="pages-page-main"

      //   data-aos-mirror="true"
      //   data-aos-once="false"
      //   data-aos-anchor-placement="top-center"
    >
    
      <div className="pages-inner-content">
        <div
          className="pages-heading-div"
          data-aos="fade-up"
          data-aos-offset="50"
          data-aos-delay="0"
          data-aos-duration="1500"
          data-aos-easing="ease-out"
        >
          <BiUser className="pages-page-icon" />
          <span className="pages-introduce">About</span>
        </div>
        <div
          data-aos="fade-up"
          data-aos-offset="50"
          data-aos-delay="0"
          data-aos-duration="1500"
          data-aos-easing="ease-out"
          className="about-introduction-heading"
        >
          Every great design begin with an even
          <span className="colored-heading"> better story</span>
        </div>
        <div
          data-aos="fade-up"
          data-aos-offset="50"
          data-aos-delay="0"
          data-aos-duration="1500"
          data-aos-easing="ease-out"
          className="about-description"
        >
          Hello! My name is Suryansh malik and I enjoy creating things that live
          on the internet. It all began with my search about website design and
          development, I came across a random video that taught me a lot about
          HTML, CSS, and web development. This sparked my interest in web
          development and I began to learn more and explore more about it; it
          has been an amazing journey and I hope it continues for a long time to
          come.
        </div>
        <div
          data-aos="fade-up"
          data-aos-offset="50"
          data-aos-delay="0"
          data-aos-duration="1500"
          data-aos-easing="ease-out"
          className="about-description"
        >
          Now, I'm a Frontend Web Developer building the Front-end of Websites
          and Web Applications that leads to the success of the overall product.
          Check out some of my work in the{" "}
          <Link to="projects" smooth={true} className="colored-description">
            Projects section
          </Link>
          .
        </div>
        {/* <div className="pages-description">
          I'm open to Job opportunities where I can contribute, learn and grow.
          If you have a good opportunity that matches my skills and experience
          then don't hesitate to contact me.
        </div> */}
      </div>
    </div>
  );
};
export default About;
